//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CreateCampaignModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    scheduledDate: {
      type: String,
      default: ""
    },
    scheduledTime: {
      type: String,
      default: ""
    },
    saving: {
      type: Boolean,
      default: false
    },
    savingSucceeded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    date() {
      return moment(`${this.scheduledDate} ${this.scheduledTime}`);
    },
    isPastDate() {
      const now = moment();
      return now >= this.date;
    }
  },
  methods: {
    showModal() {
      this.$refs.createCampaign.show();
    },
    closeModal() {
      this.$refs.createCampaign.hide();
    },
    handleSubmit() {
      this.$emit("submit");
    }
  }
});